"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const form_field_element_1 = __importDefault(require("components/form/form-field-element"));
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
require("./private-checkbox.scss");
class PrivateCheckbox extends React.Component {
    render() {
        const { isAge, name } = this.props;
        let label;
        if (isAge) {
            label = (React.createElement("span", { className: "Tooltip Tooltip--text", "data-tooltip": "Check this box if you don't want others to see the year you were born.  Team managers will always see this information." }, "Hide Age"));
        }
        else {
            label = (React.createElement("span", { className: "Tooltip Tooltip--text", "data-tooltip": "Normally, all members of your teams can see this information. If you don't want teammates to see this information, just click this checkbox. (Note: Managers and admins will always see this information.)" }, "Private"));
        }
        return (React.createElement("div", { className: "u-inlineBlock" },
            React.createElement(redux_form_1.Field, { fieldGroupClass: "private", name: name, component: form_field_element_1.default, type: "checkbox", label: label })));
    }
}
exports.default = PrivateCheckbox;
